import { render, staticRenderFns } from "./RealityAmplifyButton.vue?vue&type=template&id=e1d64202&scoped=true"
import script from "./RealityAmplifyButton.vue?vue&type=script&lang=js"
export * from "./RealityAmplifyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d64202",
  null
  
)

export default component.exports